import { Box, Grid, Typography } from "@mui/material";
import React from "react";

// Import images from the same directory
import featureImage1 from "../assets/img/Image-1.png";
import featureImage2 from "../assets/img/Image-2.png";
import featureImage3 from "../assets/img/Image-3.png";
import featureImage4 from "../assets/img/Image-4.png";

const FeaturesSection = () => {
  // Feature data array for mapping
  const features = [
    {
      id: 1,
      title: "Software Installation",
      description: "Expert installation and configuration of all software applications for your business needs.",
      image: featureImage1,
    },
    {
      id: 2,
      title: "Network Setup",
      description: "Professional configuration of secure and efficient network infrastructure for your organization.",
      image: featureImage2,
    },
    {
      id: 3,
      title: "Troubleshooting",
      description: "Fast and effective resolution of technical issues to minimize downtime and disruption.",
      image: featureImage3,
    },
    {
      id: 4,
      title: "Remote Support",
      description: "Immediate technical assistance from anywhere with secure remote access solutions.",
      image: featureImage4,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#fcfcfe",
        py: 8,
      }}
    >
      <Grid container justifyContent="center" spacing={2}>
        {features.map((feature) => (
          <Grid
            item
            key={feature.id}
            xs={12}
            sm={6}
            md={3}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: 213,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  height: 81,
                  display: "flex",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <Box
                  component="img"
                  src={feature.image}
                  alt={feature.title}
                  sx={{
                    maxWidth: 83,
                    maxHeight: 81,
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography
                variant="h5"
                sx={{
                  fontFamily: "'Inter-Medium', Helvetica",
                  fontWeight: 500,
                  color: "#333335",
                  fontSize: "23px",
                  textAlign: "center",
                  lineHeight: "27.6px",
                  mb: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Inter-Regular', Helvetica",
                  fontWeight: "normal",
                  color: "#7b787f",
                  fontSize: "15px",
                  textAlign: "center",
                  lineHeight: "23px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  width: "100%",
                }}
              >
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturesSection;